export function getFilteredComments(
  comments,
  section,
  activityId,
  showingResolvedComments
) {
  return comments.filter(function (comment) {
    if (comment.section === 'activities') {
      return showingResolvedComments
        ? comment.section === section && comment.resource_id === activityId
        : comment.section === section &&
            comment.status === 0 &&
            comment.resource_id === activityId
    } else {
      return showingResolvedComments
        ? comment.section === section
        : comment.section === section && comment.status === 0
    }
  }, this)
}

export function getResolvedComments(comments, section, activityId) {
  return comments.filter(function (comment) {
    if (comment.section === 'activities') {
      return (
        comment.section === section &&
        comment.status === 1 &&
        comment.resource_id === activityId
      )
    } else {
      return comment.section === section && comment.status === 1
    }
  })
}

export function getTotalCommentCount(comments, section, activityId) {
  return comments.filter(function (comment) {
    if (comment.section === 'activities') {
      return comment.section === section && comment.resource_id === activityId
    } else {
      return comment.section === section
    }
  }).length
}

export function getUnresolvedCommentCount(comments, section, activityId) {
  return comments.filter(function (comment) {
    if (comment.section === 'activities') {
      return (
        comment.section === section &&
        comment.status === 0 &&
        comment.resource_id === activityId
      )
    } else {
      return comment.section === section && comment.status === 0
    }
  }).length
}

export function getFriendlyCommentSectionLabel(data) {
  let retVal = ''
  switch (data.section) {
    case 'basicinformation': {
      retVal = 'Basic Information'
      break
    }
    case 'otherinformation': {
      retVal = 'Other Information'
      break
    }
    case 'images': {
      retVal = 'Images'
      break
    }
    case 'topicsandstandards': {
      retVal = 'Topics & Standards'
      break
    }
    case 'activities': {
      data.activity
        ? (retVal = `Activity ${data.activity.number}`)
        : (retVal = 'Activities')
      break
    }
    case 'questhistory': {
      retVal = 'Quest History'
      break
    }
    case 'questreview': {
      retVal = 'Quest Review'
      break
    }
    case 'skills': {
      retVal = 'Skills'
      break
    }
    default: {
      retVal = 'Unknown'
    }
  }
  return retVal
}



// WEBPACK FOOTER //
// ./src/utils/comments.js